import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider/config-context';
import { getPrefixCls } from '../_utils/general';
var BreadcrumbItem = function (props) {
    var separator = props.separator, className = props.className, style = props.style, children = props.children, customisedCls = props.prefixCls, otherProps = __rest(props, ["separator", "className", "style", "children", "prefixCls"]);
    var configContext = useContext(ConfigContext);
    var prefixCls = getPrefixCls('breadcrumb-item', configContext.prefixCls, customisedCls);
    var cls = classNames(prefixCls, className);
    return (React.createElement("li", __assign({}, otherProps, { className: cls, style: style }),
        children,
        React.createElement("span", { className: prefixCls + "__separator" }, separator)));
};
BreadcrumbItem.displayName = 'BreadcrumbItem';
export default BreadcrumbItem;
//# sourceMappingURL=breadcrumb-item.js.map